import { Close } from '@mui/icons-material';
import { Box, Card, Chip, Dialog, DialogContent, Divider,Grid, IconButton, Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DefaultMale from '../../../assets/images/default_customer_male.jpg'
import DefaultFemale from '../../../assets/images/default_customer_female.jpg'
import { Helpers } from '../../../services/Helpers';
import { CustomerService } from '../Service';
import { formatDateTime } from '../../../utils/dateUtils';
import dayjs from 'dayjs';
import { DataGrid } from '@mui/x-data-grid';
import { PermissionGuard } from '../../../components/PermissionGuard';
// kjkjkjk
const BookingHistory = ({bookingList}) => {  
  const columns = [
    { 
      field: 'bookingNumber', 
      headerName: 'Booking ID', 
      // headerAlign:'center',
      flex: 1.5,
      renderCell: (params) => (
        <PermissionGuard
          feature="booking" 
          permission="canView" 
          fallback={
              <Typography sx={{ fontSize: '0.65rem',color: '#1976d2' }}>
              #{params.row.bookingNumber}
              </Typography>
          }
          >
          <Typography 
              sx={{ 
              cursor: 'pointer', 
              fontSize: '0.65rem', 
              color: '#1976d2'
              }}
              onClick={() => window.open(`/admin/booking-details/${params.row.id}`, '_blank')}
          >
              #{params.row.bookingNumber}
          </Typography>
        </PermissionGuard>
      ),
    },
    {
      field: 'serviceDate',
      headerName: 'Service Date',
      // headerAlign:'center',
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2" sx={{fontSize:'.65rem'}} >
          {formatDateTime(params.row?.serviceDate, 'date')}
        </Typography>
      ),
    },
    {
      field: 'providerName',
      headerName: 'Expert',
      // headerAlign:'center',
      width: 150,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center',justifyContent:'left' }}>
          <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: 'bookingStatus',
      headerName: 'Status',
      // headerAlign:'center',
      flex: 1.2,
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          sx={{
            fontWeight:'500',
            fontSize:'x-small',
            color:params.value === 'requested' ? '#E8832A' : params.value === "rejected"?'#F80000':params.value === 'completed'?'#009EB4':params.value === 'accepted'?'#40B962': params.value === 'cancelled'?'#D81A23':params.value === 'ongoing'?'#1A44B8':'default',
            bgcolor:params.value === 'requested' ? '#FFEDD5' : params.value === "rejected"?'#f800001f':params.value === 'completed'?'#009eb41a':params.value === 'accepted'?'#40b96236':params.value === 'cancelled'?'#d81a231f':params.value === 'ongoing'?'#1a44b838': 'default'
          }}
        />
      ),
    },    
    {
      field: 'createdAt',headerName: 'Booking Date',headerAlign: 'center',flex:1,filterable:false,
      renderCell: (params) => (
        <Typography variant="body2" sx={{fontSize:'0.6rem',color:'#000000de'}}>{formatDateTime(params.row.createdAt)}</Typography>
      ),
    },
  ];
  return (
        <Card>
          <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
              <Typography sx={{fontWeight:'600',fontSize:'0.85rem'}}>Booking History</Typography>
          </Box>
          <DataGrid
            rows={bookingList}
            columns={columns.map((col) => ({
              ...col,
              flex: col.flex || 1, // Ensure columns resize dynamically
              minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
            }))}
            getRowId={(row) => row.id}
            // rowCount={bookingHistory}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5, 10, 15,25]}
            disableColumnMenu
            disableRowSelectionOnClick
            disableDensitySelector
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{   
              '& .MuiDataGrid-row': {
                '& .MuiDataGrid-cell': {
                  py:1
                }
              },           
              '& .MuiDataGrid-columnHeaders': {
                borderBottom: '2px solid rgba(224, 224, 224, 1)',
                borderTop: '2px solid rgba(224, 224, 224, 1)',
                fontWeight: 600,
                fontSize: '0.75rem',
                p:0,
                height: 'fit-content',
                minHeight:'0 !important',
                height:'2rem'
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
              },
              
            }}
          />
        </Card>
  );
}

export default BookingHistory;
